import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const RomanBlinds = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 553.5 390" {...props}>
      <defs>
        <pattern
          id="romanBlinds"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <linearGradient
        id="romanBlinds__a"
        x1={0}
        x2={553.338}
        y1={294.218}
        y2={294.218}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.006} stopColor="#babbbd" />
        <stop offset={0.292} stopColor="#979b9f" />
        <stop offset={0.652} stopColor="#bebdc1" />
        <stop offset={0.865} stopColor="#9d9fa3" />
        <stop offset={1} stopColor="#a6a8ab" />
        <stop offset={1} stopColor="#c2c5c9" />
      </linearGradient>
      <path fill="url(#romanBlinds)" d="M0 .1h553.5v291.6H0z" />
      <linearGradient
        id="romanBlinds__b"
        x1={277.037}
        x2={277.037}
        y1={64.57}
        y2={46.325}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__b)" d="M.9 46.3h552.3v18.2H.9z" />
      <linearGradient
        id="romanBlinds__c"
        x1={-351.515}
        x2={-351.515}
        y1={-242.625}
        y2={-260.869}
        gradientTransform="rotate(180 -37.423 -106.537)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__c)" d="M.5 29.6h552.3v18.2H.5z" />
      <linearGradient
        id="romanBlinds__d"
        x1={277.037}
        x2={277.037}
        y1={148.671}
        y2={130.427}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__d)" d="M.9 130.4h552.3v18.2H.9z" />
      <linearGradient
        id="romanBlinds__e"
        x1={-351.515}
        x2={-351.515}
        y1={-295.896}
        y2={-344.971}
        gradientTransform="rotate(180 -37.423 -106.537)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__e)" d="M.5 82.8h552.3v49.1H.5z" />
      <linearGradient
        id="romanBlinds__f"
        x1={-351.515}
        x2={-351.515}
        y1={-379.997}
        y2={-429.072}
        gradientTransform="rotate(180 -37.423 -106.537)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__f)" d="M.5 166.9h552.3V216H.5z" />
      <linearGradient
        id="romanBlinds__g"
        x1={-351.515}
        x2={-351.515}
        y1={-455.712}
        y2={-504.787}
        gradientTransform="rotate(180 -37.423 -106.537)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__g)" d="M.5 242.6h552.3v49.1H.5z" />
      <linearGradient
        id="romanBlinds__h"
        x1={277.037}
        x2={277.037}
        y1={232.773}
        y2={214.529}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__h)" d="M.9 214.5h552.3v18.2H.9z" />
      <linearGradient
        id="romanBlinds__i"
        x1={-981.769}
        x2={-981.769}
        y1={-393.671}
        y2={-411.915}
        gradientTransform="translate(1258.805 411.915)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#romanBlinds__i)" d="M.9 0h552.3v18.2H.9z" />
    </svg>
  );
};
